import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import './styles/index.css';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'ap-northeast-1_qjgrtbzGz',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '38rvjgcq9kukds2ft1s8c6mroc',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'ea-guide-viewer-20251224125510.auth.ap-northeast-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN || window.location.origin + '/'],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT || window.location.origin + '/'],
          responseType: 'code'
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
